// extracted by mini-css-extract-plugin
export default {"PurchaseItem":"PurchaseItem_PurchaseItem__xYXNp"};